// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialogTheme .el-dialog__header{padding:5px 5px 5px 5px}.dialogTheme .el-dialog__headerbtn{top:5px;right:5px}.dialogTheme .el-dialog__headerbtn .el-dialog__close{color:#7a3636}.dialogTheme .el-dialog__body{padding:5px 5px}\n", ""]);
// Exports
module.exports = exports;
